export interface HeroImage {
  id: string;
  url: string;
  captionEn?: string;
  captionAr?: string;
}

const STORAGE_KEY = 'ahg_hero_images_v1';

export const DEFAULT_HERO_IMAGES: HeroImage[] = [
{
  id: 'hero-2',
  url: "/How-to-Spend-A-Night-in-Alexandria-Trips-In-Egypt.jpg",
  captionEn: 'Stanley Bridge at Night',
  captionAr: 'كوبري ستانلي ليلاً'
},
{
  id: 'hero-3',
  url: "/5db795b8603a1e2b548b131744b10684b720a0e3f7f29ee2c6d8d24f727deda3.webp",
  captionEn: 'Qaitbay Citadel from Above',
  captionAr: 'قلعة قايتباي من الأعلى'
},
{
  id: 'hero-4',
  url: "/0527-1119_alexandria.jpg",
  captionEn: 'Qaitbay Citadel Courtyard',
  captionAr: 'ساحة قلعة قايتباي'
},
{
  id: 'hero-5',
  url: "/07307ae9b9dcc8a78e5bf763772f441c90a7fc226b76695006b9e4f414880c87.webp",
  captionEn: 'Bibliotheca Alexandrina',
  captionAr: 'مكتبة الإسكندرية'
},
{
  id: 'hero-6',
  url: "/hero-passage-through-egypt-alexandria-extension.jpg.adapt.nineteen-hundred.jpg",
  captionEn: 'Abu Al-Abbas Al-Mursi Mosque',
  captionAr: 'مسجد أبو العباس المرسي'
},
{
  id: 'hero-1',
  url: "/44459a77edb1feadac9a0916c968ee636d9731da2ae0e37355dc1aa68be8f53b.webp",
  captionEn: "Pompey's Pillar & the Sphinx",
  captionAr: 'عمود السواري وأبو الهول'
},
{
  id: 'hero-7',
  url: "/05b0b8fe3fbe493ff00973ebc64a585a8562d11b6e9531a662588978dc6fc317.webp",
  captionEn: 'The Roman Amphitheatre',
  captionAr: 'المدرج الروماني'
},
{
  id: 'hero-8',
  url: "/18c4781e093059d1e6d18f36a5727220a8b9ee5f73848306bd89325f88bc8d30.webp",
  captionEn: 'The Eastern Harbour',
  captionAr: 'الميناء الشرقي'
},
{
  id: 'hero-9',
  url: "/Alexandria,_Egypt_AdobeStock_190924977.webp",
  captionEn: 'Stanley Bridge at Sunset',
  captionAr: 'كوبري ستانلي عند الغروب'
},
{
  id: 'hero-10',
  url: "/Generated_Image_May_12,_2026_-_4_20PM.jpg",
  captionEn: 'Montaza Palace & Gardens',
  captionAr: 'قصر وحدائق المنتزه'
}];


/** Read the persisted hero images. Falls back to defaults if missing or invalid. */
export function loadHeroImages(): HeroImage[] {
  if (typeof window === 'undefined') return DEFAULT_HERO_IMAGES;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return DEFAULT_HERO_IMAGES;
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed) || parsed.length === 0)
    return DEFAULT_HERO_IMAGES;
    return parsed.filter(
      (item): item is HeroImage =>
      item && typeof item.id === 'string' && typeof item.url === 'string'
    );
  } catch {
    return DEFAULT_HERO_IMAGES;
  }
}

/** Persist hero images and broadcast a change event so listeners can react. */
export function saveHeroImages(images: HeroImage[]): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(images));
    window.dispatchEvent(new CustomEvent('ahg:hero-images-changed'));
  } catch {

    // Ignore quota/permissions errors
  }}

/** Restore the default set and broadcast. */
export function resetHeroImages(): HeroImage[] {
  saveHeroImages(DEFAULT_HERO_IMAGES);
  return DEFAULT_HERO_IMAGES;
}